var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team.general.day_detail"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      modalExtraLarge: true,
      "loading-primary-footer-button": _vm.isLoading,
      showSecondaryFooterButton: false,
      showPrimaryFooterButton: false,
    },
    on: _vm._d({}, [_vm.closeEvent, _vm.onCloseButtonClicked]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "portal-employee-card day-detail-employee" },
              [
                _c(
                  "div",
                  {
                    staticClass: "portal-employee-card__icon",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("i", { staticClass: "fas fa-user" })]
                ),
                _c("div", { staticClass: "portal-employee-card__meta" }, [
                  _c("span", { staticClass: "portal-employee-card__label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.planing-team-validate.employee_name")
                        ) +
                        " "
                    ),
                  ]),
                  _c("strong", { staticClass: "portal-employee-card__name" }, [
                    _vm._v(_vm._s(_vm.employeeName)),
                  ]),
                  _c("span", { staticClass: "portal-employee-card__sub" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.planing-team-validate.employee_id")
                        ) +
                        ": " +
                        _vm._s(_vm.employeeCode) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "day-detail-date" },
                  [
                    _c("formatted-date-component", {
                      attrs: { val: _vm.currentDate },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c("vue-data-table", {
              attrs: {
                classTable: _vm.classTable,
                "table-columns": _vm.columns,
                "table-rows": _vm.rows,
                "is-loading": _vm.isLoading,
                showRefreshButton: false,
                showRowTableAction: false,
                "empty-rows-message": _vm.$t("components.table.no_data"),
              },
              scopedSlots: _vm._u([
                {
                  key: "table-row",
                  fn: function (props) {
                    return [
                      props.cell.getColumn.id == "employee.holidaysRemaining"
                        ? [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                        : props.cell.getColumn.id == "employee.hourBalance"
                        ? [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                        : !["actions"].includes(props.cell.getColumn.id)
                        ? [
                            _c("plan-day-item-table-component", {
                              attrs: { cellData: props.cell },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "description",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "row my-2" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("hour-planned-legend", {
                              staticClass: "m-1",
                              staticStyle: { width: "170px" },
                              attrs: { rounded: true },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "row my-2" }, [
                        _c(
                          "div",
                          { staticClass: "col d-flex flex-wrap" },
                          [
                            _c("absence-justified-day-legend", {
                              staticClass: "m-1",
                            }),
                            _c("absence-unjustified-day-legend", {
                              staticClass: "m-1",
                            }),
                            _c("absence-confirm-waiting-day-legend", {
                              staticClass: "m-1",
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "row my-2" }, [
                        _c(
                          "div",
                          { staticClass: "col d-flex flex-wrap" },
                          [
                            _c("vacations-approved-day-legend", {
                              staticClass: "m-1",
                            }),
                            _c("vacation-confirm-waiting-day-legend", {
                              staticClass: "m-1",
                            }),
                            _c("vacations-need-meeting-day-legend", {
                              staticClass: "m-1",
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "row my-2" }, [
                        _c(
                          "div",
                          { staticClass: "col d-flex flex-wrap" },
                          [
                            _c("off-day-legend", { staticClass: "m-1" }),
                            _c("sick-day-legend", { staticClass: "m-1" }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }